import API from '../../../../../services/api';

export const VENTAS_API = {
    get: async (archivado = false, page = null, search = null) => {
        return await API.get(`/ventas?page=${page}&archivado=${archivado}${search || ''}`).then(res => res.data);
    },
    getPendientes: async() => {
        return await API.get('/ventas/pendientes').then(res => res.data);
    },
    getById: async (idVenta) => {
        return API.get('/ventas/' + idVenta + '/completa').then(res => res.data);
    },
    uploadProviderInvoice: async (venta, ventaId) => {
        return API.post(`/ventas/${ventaId}/upload`, venta).then(res => res.data);
    },
    downloadProviderInvoice: async (filename) => {
        return API.get(`/ventas/${filename}/download`, {responseType: 'arraybuffer'}).then(res => res.data);
    },
    sendIncidentEmail: async (ventaId) => {
        return API.post(`/ventas/${ventaId}/formulario-incidencia`).then(res => res.data);
    },
    update: async (venta) => {
        return API.put(`/ventas/${venta.id}`, venta).then(res => res.data);
    },
    enviarEmailRecogeCliente: async (presupuestoNum) => {
        return API.post('/almacen/entity/email-recoge-cliente', { presupuestoNum, isFromCrm: true }).then(res => res.data);
    }
}